import { createSlice } from "@reduxjs/toolkit";
import i18next from "../../i18n"; // import your i18n instance

const initialState = {
  faceIO: null,
  sideBarVisible: false,
  sideBarDetailVisible: false,
  language: "en",
  languageId: 1,
};

const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setFaceIO: (state, action) => ({ ...state, faceIO: action.payload }),
    setSideBarVisible: (state, action) => ({
      ...state,
      sideBarVisible: action.payload,
    }),
    setSideBarDetailVisible: (state, action) => ({
      ...state,
      sideBarDetailVisible: action.payload,
    }),
    setLanguage: (state, action) => {
      const lang = action.payload;
      let langId = 1;

      switch (lang) {
        case "en":
          langId = 1;
          break;
        case "ar":
          langId = 2;
          break;
        case "fr":
          langId = 3;
          break;
        default:
          langId = 1;
      }

      i18next.changeLanguage(lang);

      return {
        ...state,
        language: lang,
        languageId: langId,
      };
    },
  },
});

export default appSlice.reducer;
export const {
  setFaceIO,
  setSideBarVisible,
  setSideBarDetailVisible,
  setLanguage,
} = appSlice.actions;
